import { render, staticRenderFns } from "./mf_index.vue?vue&type=template&id=306f38ce&scoped=true&"
import script from "./mf_index.vue?vue&type=script&lang=js&"
export * from "./mf_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f38ce",
  null
  
)

export default component.exports